module.exports = __webpack_public_path__ + "img/1999.e1d36a06.jpg";